import { useForm } from 'react-hook-form';

import { State } from '@/types';

import { TChannelRecordingForm } from '../types';

export const DEFAULT_VALUES: Partial<TChannelRecordingForm> = {
  state: State.Active,
  segment_duration: 120,
  description: '',
  channel_id: '',
  production_center_id: '',
  schedule: [],
};

export function useChannelRecordingDrawerFormState() {
  const form = useForm<TChannelRecordingForm>({
    mode: 'all',
    defaultValues: DEFAULT_VALUES,
  });

  return { form };
}
